/**
 * @fileoverview gRPC-Web generated client stub for hrepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/hr/hr.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_hr_pb = require('../../xcommon/hr_pb.js')

var xcommon_collection_pb = require('../../xcommon/collection_pb.js')
const proto = {};
proto.hrepb = require('./hr_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.hrepb.HrServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.hrepb.HrServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetArchiveReq,
 *   !proto.xcommon.GetArchiveResp>}
 */
const methodDescriptor_HrService_GetArchive = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/GetArchive',
  grpc.web.MethodType.UNARY,
  xcommon_hr_pb.GetArchiveReq,
  xcommon_hr_pb.GetArchiveResp,
  /**
   * @param {!proto.xcommon.GetArchiveReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_hr_pb.GetArchiveResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetArchiveResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetArchiveResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.getArchive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/hrepb.HrService/GetArchive',
      request,
      metadata || {},
      methodDescriptor_HrService_GetArchive,
      callback);
};


/**
 * @param {!proto.xcommon.GetArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetArchiveResp>}
 *     Promise that resolves to the response
 */
proto.hrepb.HrServicePromiseClient.prototype.getArchive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/hrepb.HrService/GetArchive',
      request,
      metadata || {},
      methodDescriptor_HrService_GetArchive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveArchiveReq,
 *   !proto.xcommon.SaveArchiveResp>}
 */
const methodDescriptor_HrService_CreateArchive = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/CreateArchive',
  grpc.web.MethodType.UNARY,
  xcommon_hr_pb.SaveArchiveReq,
  xcommon_hr_pb.SaveArchiveResp,
  /**
   * @param {!proto.xcommon.SaveArchiveReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_hr_pb.SaveArchiveResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveArchiveResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveArchiveResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.createArchive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/hrepb.HrService/CreateArchive',
      request,
      metadata || {},
      methodDescriptor_HrService_CreateArchive,
      callback);
};


/**
 * @param {!proto.xcommon.SaveArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveArchiveResp>}
 *     Promise that resolves to the response
 */
proto.hrepb.HrServicePromiseClient.prototype.createArchive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/hrepb.HrService/CreateArchive',
      request,
      metadata || {},
      methodDescriptor_HrService_CreateArchive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveArchiveReq,
 *   !proto.xcommon.SaveArchiveResp>}
 */
const methodDescriptor_HrService_UpdateArchive = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/UpdateArchive',
  grpc.web.MethodType.UNARY,
  xcommon_hr_pb.SaveArchiveReq,
  xcommon_hr_pb.SaveArchiveResp,
  /**
   * @param {!proto.xcommon.SaveArchiveReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_hr_pb.SaveArchiveResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveArchiveResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveArchiveResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.updateArchive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/hrepb.HrService/UpdateArchive',
      request,
      metadata || {},
      methodDescriptor_HrService_UpdateArchive,
      callback);
};


/**
 * @param {!proto.xcommon.SaveArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveArchiveResp>}
 *     Promise that resolves to the response
 */
proto.hrepb.HrServicePromiseClient.prototype.updateArchive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/hrepb.HrService/UpdateArchive',
      request,
      metadata || {},
      methodDescriptor_HrService_UpdateArchive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveArchiveReq,
 *   !proto.xcommon.SaveArchiveResp>}
 */
const methodDescriptor_HrService_DeleteArchivePanel = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/DeleteArchivePanel',
  grpc.web.MethodType.UNARY,
  xcommon_hr_pb.SaveArchiveReq,
  xcommon_hr_pb.SaveArchiveResp,
  /**
   * @param {!proto.xcommon.SaveArchiveReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_hr_pb.SaveArchiveResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveArchiveResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveArchiveResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.deleteArchivePanel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/hrepb.HrService/DeleteArchivePanel',
      request,
      metadata || {},
      methodDescriptor_HrService_DeleteArchivePanel,
      callback);
};


/**
 * @param {!proto.xcommon.SaveArchiveReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveArchiveResp>}
 *     Promise that resolves to the response
 */
proto.hrepb.HrServicePromiseClient.prototype.deleteArchivePanel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/hrepb.HrService/DeleteArchivePanel',
      request,
      metadata || {},
      methodDescriptor_HrService_DeleteArchivePanel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOfficeListReq,
 *   !proto.xcommon.GetOfficeListResp>}
 */
const methodDescriptor_HrService_GetOfficeList = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/GetOfficeList',
  grpc.web.MethodType.UNARY,
  xcommon_hr_pb.GetOfficeListReq,
  xcommon_hr_pb.GetOfficeListResp,
  /**
   * @param {!proto.xcommon.GetOfficeListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_hr_pb.GetOfficeListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOfficeListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetOfficeListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOfficeListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.getOfficeList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/hrepb.HrService/GetOfficeList',
      request,
      metadata || {},
      methodDescriptor_HrService_GetOfficeList,
      callback);
};


/**
 * @param {!proto.xcommon.GetOfficeListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOfficeListResp>}
 *     Promise that resolves to the response
 */
proto.hrepb.HrServicePromiseClient.prototype.getOfficeList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/hrepb.HrService/GetOfficeList',
      request,
      metadata || {},
      methodDescriptor_HrService_GetOfficeList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UploadDocumentReq,
 *   !proto.xcommon.UploadDocumentResp>}
 */
const methodDescriptor_HrService_UploadDocument = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/UploadDocument',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.UploadDocumentReq,
  xcommon_collection_pb.UploadDocumentResp,
  /**
   * @param {!proto.xcommon.UploadDocumentReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.UploadDocumentResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.UploadDocumentReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.UploadDocumentResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.UploadDocumentResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.uploadDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/hrepb.HrService/UploadDocument',
      request,
      metadata || {},
      methodDescriptor_HrService_UploadDocument,
      callback);
};


/**
 * @param {!proto.xcommon.UploadDocumentReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.UploadDocumentResp>}
 *     Promise that resolves to the response
 */
proto.hrepb.HrServicePromiseClient.prototype.uploadDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/hrepb.HrService/UploadDocument',
      request,
      metadata || {},
      methodDescriptor_HrService_UploadDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DownloadDocumentReq,
 *   !proto.xcommon.DownloadDocumentResp>}
 */
const methodDescriptor_HrService_DownloadDocument = new grpc.web.MethodDescriptor(
  '/hrepb.HrService/DownloadDocument',
  grpc.web.MethodType.SERVER_STREAMING,
  xcommon_collection_pb.DownloadDocumentReq,
  xcommon_collection_pb.DownloadDocumentResp,
  /**
   * @param {!proto.xcommon.DownloadDocumentReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.DownloadDocumentResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DownloadDocumentReq} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DownloadDocumentResp>}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServiceClient.prototype.downloadDocument =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/hrepb.HrService/DownloadDocument',
      request,
      metadata || {},
      methodDescriptor_HrService_DownloadDocument);
};


/**
 * @param {!proto.xcommon.DownloadDocumentReq} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DownloadDocumentResp>}
 *     The XHR Node Readable Stream
 */
proto.hrepb.HrServicePromiseClient.prototype.downloadDocument =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/hrepb.HrService/DownloadDocument',
      request,
      metadata || {},
      methodDescriptor_HrService_DownloadDocument);
};


module.exports = proto.hrepb;

